import { useCallback } from 'react';

import { useMutation, useQuery } from '@tanstack/react-query';

import {
  getCurrentUser,
  loginClient,
  refreshToken,
  registerUserCompanyInfo,
  registerUserPersonalInfo,
  resetForgetPassword,
  resetPassswordSendCode,
  resetPassswordVerifyCode,
  sendCode,
  verifyEmail,
} from './authentication-client';
import {
  IForgetResetPassword,
  IRegisterUserCompanyInfoRequest,
  IRegisterUserInfoRequest,
  IUserCredentials,
} from './types';

export const useRegisterUserPersonalInfo = () => {
  const mutationFn = useCallback(
    async (data: IRegisterUserInfoRequest) => registerUserPersonalInfo(data),
    []
  );

  return useMutation({
    mutationFn,
  });
};

export const useRegisterCompanyInfo = () => {
  const mutationFn = useCallback(
    async (data: IRegisterUserCompanyInfoRequest) =>
      registerUserCompanyInfo(data),
    []
  );

  return useMutation({
    mutationFn,
  });
};

export const useVerifyEmail = () => {
  const mutationFn = useCallback(async (code: string) => verifyEmail(code), []);

  return useMutation({
    mutationFn,
  });
};

export const useLogin = () => {
  const mutationFn = useCallback(
    async (credentials: IUserCredentials) => loginClient(credentials),
    []
  );

  return useMutation({
    mutationFn,
  });
};

export const useResetPassswordSendCode = () => {
  const mutationFn = useCallback(
    async (email: string) => resetPassswordSendCode(email),
    []
  );

  return useMutation({
    mutationFn,
  });
};

export const useResetPasswordVerifyCode = () => {
  const mutationFn = useCallback(
    async (data: IForgetResetPassword) => resetPassswordVerifyCode(data),
    []
  );

  return useMutation({
    mutationFn,
  });
};

export const useResetForgetPassword = () => {
  const mutationFn = useCallback(
    async (password: string) => resetForgetPassword(password),
    []
  );

  return useMutation({
    mutationFn,
  });
};

export const useSendCode = () => {
  const mutationFn = useCallback(async () => sendCode(), []);

  return useMutation({
    mutationFn,
  });
};

export const useRefreshToken = () => {
  const mutationFn = useCallback(
    async (refToken: string) => refreshToken(refToken),
    []
  );

  return useMutation({
    mutationFn,
  });
};

export const useGetCurrentUser = () => {
  const queryFn = useCallback(async () => getCurrentUser(), []);

  return useQuery({
    queryKey: ['getCurrentUser'],
    queryFn,
    retry: false,
  });
};
